import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'oc_access_token';

// A Google-lel belépett ügyfélnek nincs JWT-je, csak session sütije — ezért
// minden portál hívás withCredentials-szel megy.
export const authCfg = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return {
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  };
};

export const portalGet = (path, params) =>
  axios.get(`${API}/api/portal${path}`, { ...authCfg(), params }).then(r => r.data);

export const portalPost = (path, body) =>
  axios.post(`${API}/api/portal${path}`, body, authCfg()).then(r => r.data);

export const portalPut = (path, body) =>
  axios.put(`${API}/api/portal${path}`, body, authCfg()).then(r => r.data);

export const portalDelete = (path) =>
  axios.delete(`${API}/api/portal${path}`, authCfg()).then(r => r.data);

export const apiError = (err, fallback = 'Valami hiba történt.') => {
  const d = err?.response?.data?.detail;
  // A FastAPI validációs hibái angolul jönnek, tömbben — ezt magyarra cseréljük.
  if (Array.isArray(d)) return 'Hibás vagy hiányzó érték — ellenőrizd a megadott számokat.';
  if (typeof d === 'string') return d;
  return fallback;
};

export const hu = (n, d = 0) =>
  Number(n || 0).toLocaleString('hu-HU', { maximumFractionDigits: d });

// Helyi (magyar) dátum — nem UTC, különben éjfél után még a tegnapi nap jönne.
export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const shiftDate = (iso, days) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const prettyDate = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  const nap = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'][d.getDay()];
  return `${d.getMonth() + 1}. ${d.getDate()}. ${nap}`;
};
